module.exports = __webpack_public_path__ + "static/img/empty-platform_256.ed6489a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/empty-platform_256.png
// module id = O/3m
// module chunks = 0